import * as ExpoClipboard from 'expo-clipboard';

export default abstract class BaseClipboardImpl {
  getStringAsync() {
    return ExpoClipboard.getStringAsync();
  }
}
